export default __webpack_public_path__ + "static/B0258-ea99876ed782fc8790b88c1827b51ed1.png";